import { AuthGuard } from '../../shared/guards/AuthGuard';
import { SicoobBoletoPresentation } from './components';
import { Sidebar } from '../../shared/components';

export const SicoobBoletoPage = (): JSX.Element => {
    return (
        <SicoobBoletoPresentation />
        )
};